export default {
  SET_AUTHENTICATED: 'setAuthenticated',
  SET_TOKEN: 'setToken',
  SET_USER_DATA: 'setUserData',
  SET_APP_MESSAGE_TYPE: 'setAppMessageType',
  SET_APP_MESSAGE_TEXT: 'setAppMessageText',
  SET_APP_MESSAGE_OPEN: 'setAppMessageOpen'
}
